var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:`${_vm.theme}-theme`},[(_vm.isAuthorized)?_c('PanelView',{attrs:{"theme":_vm.theme,"size":_vm.size}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }